import { c as _c } from "react/compiler-runtime";
import { B2BInquiryPropertiesTypes } from "@website/widget/login/components/b2b-inquiry/types";
import { AuthB2BRequestOtpService } from "@website/widget/login/services/auth-b2b-request-otp";
import { isPhoneNumberPartiallyValid, isPhoneNumberValid } from "@website/widget/login/utils";
import { ChangeEvent, useState } from "react";
export const useB2BInquiry = properties => {
  const $ = _c(14);
  const {
    setStep,
    setUserData,
    userData
  } = properties;
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [contractId, setContractId] = useState("");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = event => {
      const {
        value
      } = event.target;
      if (isPhoneNumberPartiallyValid(value)) {
        setPhoneNumber(value);
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const onChangePhoneNumber = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = event_0 => {
      const {
        value: value_0
      } = event_0.target;
      setContractId(value_0);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onChangeContractId = t1;
  let t2;
  if ($[2] !== contractId || $[3] !== phoneNumber || $[4] !== setStep || $[5] !== setUserData || $[6] !== userData) {
    t2 = async _event => {
      _event.preventDefault();
      if (isPhoneNumberValid(phoneNumber) && contractId) {
        setIsLoading(true);
        setError("");
        AuthB2BRequestOtpService({
          phoneNumber
        }).then(data => {
          setUserData({
            ...userData,
            ...data,
            phoneNumber,
            contractId
          });
          setStep("otp");
        }).catch(error_0 => {
          setError(error_0?.response?.data?.message || error_0?.response?.message || "\u062E\u0637\u0627\u06CC\u06CC \u0631\u062E \u062F\u0627\u062F\u0647\u060C \u062F\u0648\u0628\u0627\u0631\u0647 \u062A\u0644\u0627\u0634 \u06A9\u0646\u06CC\u062F.");
        }).finally(() => setIsLoading(false));
      } else {
        setError("\u0627\u0637\u0644\u0627\u0639\u0627\u062A \u0648\u0627\u0631\u062F \u0634\u062F\u0647 \u0635\u062D\u06CC\u062D \u0646\u0645\u06CC\u0628\u0627\u0634\u062F.");
      }
    };
    $[2] = contractId;
    $[3] = phoneNumber;
    $[4] = setStep;
    $[5] = setUserData;
    $[6] = userData;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const onSubmitPhoneNumber = t2;
  let t3;
  if ($[8] !== contractId || $[9] !== error || $[10] !== isLoading || $[11] !== onSubmitPhoneNumber || $[12] !== phoneNumber) {
    t3 = {
      error,
      isLoading,
      phoneNumber,
      contractId,
      onChangePhoneNumber,
      onSubmitPhoneNumber,
      onChangeContractId
    };
    $[8] = contractId;
    $[9] = error;
    $[10] = isLoading;
    $[11] = onSubmitPhoneNumber;
    $[12] = phoneNumber;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
};